var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBank = function SvgBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M0 8.5V10h2v-.5l10-6.3 10 6.3v.5h2V8.5L12 .8zM23 21H1v2h22zM18 12h1v6h-3v-6h1v-2h-4v2h1v6h-1v-3h-2v3h-1v-6h1v-2H7v2h1v6H5v-6h1v-2H2v2h1v6H2v2h20v-2h-1v-6h1v-2h-4z"
  })));
};
export default SvgBank;